import { render, staticRenderFns } from "./ModalPICSkeleton.vue?vue&type=template&id=76551386"
import script from "./ModalPICSkeleton.vue?vue&type=script&lang=js"
export * from "./ModalPICSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports